/** Persist affiliate/invite codes from URLs across signup flows. */

const STORAGE_KEY = 'pairvelle_affiliate_ref'

export function captureAffiliateRefFromLocation(): string | null {
  if (typeof window === 'undefined') return null
  const hash = window.location.hash
  const hashQuery = hash.includes('?') ? hash.slice(hash.indexOf('?') + 1) : ''
  const search = window.location.search.replace(/^\?/, '')
  const params = new URLSearchParams(hashQuery || search)
  const ref = (params.get('ref') ?? params.get('affiliate') ?? '').trim().toLowerCase()
  if (ref && /^[a-z0-9]{3,16}$/.test(ref)) {
    try {
      localStorage.setItem(STORAGE_KEY, ref)
    } catch {
      /* ignore */
    }
    return ref
  }
  return getStoredAffiliateRef()
}

export function getStoredAffiliateRef(): string | null {
  try {
    const v = localStorage.getItem(STORAGE_KEY)
    if (v && /^[a-z0-9]{3,16}$/.test(v)) return v
  } catch {
    /* ignore */
  }
  return null
}

export function clearStoredAffiliateRef() {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    /* ignore */
  }
}
